import axios from "axios"
import { useAuth0 } from "@auth0/auth0-react"
import { useQuery } from "@tanstack/react-query"
import { usePermissionsList } from "./queries/usePermissions"
import { getDateFormatted, getFirstOpenDateToday } from "../utils/generalUtils"
import useFetchSettings from "./useFetchSettings"

const useFetchAnalyze = () => {
	const { getAccessTokenSilently, isAuthenticated, user } = useAuth0()
	const permissionsData = usePermissionsList()
	const { settingsData } = useFetchSettings()

	const testEnvironment = user?.org_id === "org_lkg3WMhi3Q2l92iT"
	const centerOpen = settingsData?.centerOpen
	const centerClosedDates = settingsData?.center_closed_dates ?? []

	const date = settingsData
		? getDateFormatted(
				getFirstOpenDateToday(centerOpen, testEnvironment, centerClosedDates)
			)
		: null

	const canRead = permissionsData?.includes("read:schedules") ?? false

	const query = useQuery({
		queryKey: ["daily-huddle", date],
		queryFn: async () => {
			const token = await getAccessTokenSilently({
				authorizationParams: { audience: process.env.REACT_APP_API_IDENTIFIER }
			})
			const response = await axios.get(
				`${process.env.REACT_APP_BACKEND_URL}/api/daily-huddle?date=${date}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			return response.data.payload
		},
		enabled: isAuthenticated && !!date && canRead,
		staleTime: 1000 * 60 * 5
	})

	return {
		analyzeData: query.data,
		isLoading: query.isLoading,
		isFetching: query.isFetching,
		error: query.error
	}
}

export default useFetchAnalyze
